module.exports = __webpack_public_path__ + "img/lssh_qrcode.978ab4b1.jpg";